'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { openShareDrawer } from '@/app/_components/GlobalModal/_components/ShareDrawer';
import { Image } from '@/components/client';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';

/**
 * ⑩ 회원가입 CTA + 공유 + 면책 + 출처.
 * - 메인 CTA: 비로그인 → 로그인 페이지, 로그인 → 맞춤정책 페이지.
 * - 공유: 전역 ShareDrawer (Kakao SDK / Web Share / 클립보드 폴백 통합).
 */
export const FinalCta = () => {
  const $ = _c(11);
  const router = useCustomRouter();
  const isLogin = useAuthStore(_temp);
  let t0;
  if ($[0] !== isLogin || $[1] !== router) {
    t0 = () => {
      if (isLogin === undefined) {
        return;
      }
      if (!isLogin) {
        router.push(ROUTES.LOGIN.withSearchParams({
          searchParams: {
            redirect: ROUTES.RECOMMEND_POLICY_LIST.pathname
          }
        }));
        return;
      }
      router.push(ROUTES.RECOMMEND_POLICY_LIST.pathname);
    };
    $[0] = isLogin;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleCtaClick = t0;
  const handleShare = _temp2;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image src="https://www.welfarehello.com/assets/pngs/silver-coin.png" alt={"\uB85C\uACE0 \uC2E4\uBC84 \uCF54\uC778 \uC774\uBBF8\uC9C0"} className="size-120" width={120} height={120} />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="text-Gray-500 typo-body4">회원가입하고</p>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col items-center gap-2 text-center">{t2}<p className="text-Gray-900 typo-body3"><strong className="font-700">내게 딱 맞는 정책</strong> 확인하기</p></div>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== handleCtaClick) {
    t4 = <Button theme="primary-fill" dimensions="H48" className="w-full" onClick={handleCtaClick}>내 맞춤정책 확인하기 →</Button>;
    $[6] = handleCtaClick;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Button theme="sub-line" dimensions="H48" className="w-full" onClick={handleShare}>공유하기</Button>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <section className="flex flex-col gap-16 mobile-tablet:px-16"><div className="flex flex-col items-center gap-16 py-24">{t1}{t3}<div className="flex w-full flex-col gap-12">{t4}{t5}</div></div></section>;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2() {
  if (typeof window === "undefined") {
    return;
  }
  openShareDrawer(window.location.href);
}